import React, { FC } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import PolicyTemplatesLayout from './PolicyTemplatesLayout';
import { PolicyConfigurationProvider } from './context/PolicyConfigurationContext';
import { DEFAULT_POLICY_TEMPLATE } from '../../../types/policies';

interface RouteParams {
    categoryId?: string;
}

const PolicyTemplates: FC = () => {
    const { categoryId } = useParams<RouteParams>();

    if (!categoryId) {
        // @ts-ignore - TODO: solve like the other react router dom ts issues
        return <Redirect to={`/Policy/Templates/${DEFAULT_POLICY_TEMPLATE}`} />;
    }

    return (
        <PolicyConfigurationProvider>
            <PolicyTemplatesLayout categoryId={categoryId} />
        </PolicyConfigurationProvider>
    );
};

export default PolicyTemplates;
